import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const TOOLTIP_DELAY = { show: 0, hide: 80 };

export const HintTip = ({ id, text, children, placement = 'top' }) => {
  if (!text) return children || null;
  return (
    <OverlayTrigger
      placement={placement}
      delay={TOOLTIP_DELAY}
      overlay={<Tooltip id={id}>{text}</Tooltip>}
    >
      <span className="d-inline-flex align-items-center" style={{ cursor: 'default' }}>{children}</span>
    </OverlayTrigger>
  );
};

export const FieldLabel = ({ children, hint, hintId, required }) => (
  <label className="small font-weight-bold text-muted mb-1 d-flex align-items-center" style={{ gap: '4px', whiteSpace: 'nowrap' }}>
    <span>{children}{required ? ' *' : ''}</span>
    {hint ? (
      <HintTip id={hintId || 'bulk-create-field-hint'} text={hint}>
        <i className="bi bi-info-circle" style={{ fontSize: '0.8rem', opacity: 0.65 }} />
      </HintTip>
    ) : null}
  </label>
);
